export const thCustomersArray = [
  {
    Header: "Company Name",
    accessor: "Company_Name"
  },
  {
    Header: "Primary Contact",
    accessor: "Name"
  },
  {
    Header: "Phone Number",
    accessor: "contactno"
  },
  {
    Header: "Email Address",
    accessor: "email"
  },

  {
    Header: "Campaigns Not Started",
    accessor: "Notstarted"
  },
  {
    Header: "Live Campaigns",
    accessor: "Live"
  },
  {
    Header: "Paused Campaigns",
    accessor: "Paused"
  },
  {
    Header: "Completed Campaigns",
    accessor: "Completed"
  },
  {
    Header: "Active",
    accessor: "Active"
  }
];

export const thCampaignsArray = [
  // {
  //   Header: "# Invites",
  //   accessor: "invited"
  // },
  // {
  //   Header: "# Connected",
  //   accessor: "NumberConnected"
  // },
  // {
  //   Header: "% Connected",
  //   accessor: "Connected"
  // },
  // {
  //   Header: "# Engaged",
  //   accessor: "Engaged"
  // },
  // {
  //   Header: "% Engaged",
  //   accessor: "EngagedPercent"
  // },
  // {
  //   Header: "# Leads",
  //   accessor: "leads"
  // },
  // {
  //   Header: "% Leads",
  //   accessor: "LeadsPercent"
  // }
];
export const thCampaignsArray2 = [];
